<template>
  <aside
    :class="['mcart', { 'mcart--open': isCartOpen }]"
    aria-labelledby="cart-title"
    v-focus-trap="isCartOpen"
    role="dialog"
    aria-modal="true"
    :aria-hidden="!isCartOpen"
  >
    <CartBody
      :isCartOpen="isCartOpen"
      :cartConfirmationObj="cartConfirmationObj"
      @on-toggle="toggle"
      @change-cartConfirmationObj="changeCartConfirmationObj"
    />
  </aside>
</template>

<script setup>
  import { ref, onBeforeMount, getCurrentInstance, computed, watch } from 'vue';
  import CartBody from './components/cart-body.vue';
  import { useStore } from 'vuex';

  var isCartOpen = ref(false);
  var cartConfirmationObj = ref({
    visiblity: false,
    message: 'Item Added To Cart',
    line: 1,
  });
  const isCompForcefullyUpdated = ref(false);
  const overlay = new window.Overlay();
  const instance = getCurrentInstance();
  const store = useStore();

  const totalCount = computed(() => store.state.cart.item_count);

  onBeforeMount(async () => {
    // Setting window function for toggle
    window.openCart = toggle;
  });

  const changeCartConfirmationObj = (res) => {
    cartConfirmationObj.value = res;
  };

  const updateComponentIfNeeded = () => {
    const count = totalCount?.value;

    // Determine if an update is required
    const updateRequired = count === 0 || (count === 1 && !isCompForcefullyUpdated.value);

    if (updateRequired) {
      // Update the forceful update flag if necessary
      if (count === 0) {
        isCompForcefullyUpdated.value = false;
      } else if (count === 1) {
        isCompForcefullyUpdated.value = true;
      }

      // Check if the cart is open and perform the update
      if (isCartOpen.value) {
        instance?.proxy?.$forceUpdate();
        console.log('mini cart component updated!');
      }
    }
  };

  function toggle(params) {
    const op = typeof params.open === 'boolean' ? params.open : !isCartOpen.value;
    isCartOpen.value = op;
    cartConfirmationObj.value.visiblity = params.cartConfirmation;
    cartConfirmationObj.value.itemRemoved = false;
    let bodyStyle = document.body.style;

    if (op) {
      window.drawerComponents.forEach((drawer) => {
        window.toggleDrawer(false, drawer.componentName);
      });
      overlay.show();
      bodyStyle.overflow = 'hidden';
      logCartDetailsToSegment();
    } else {
      overlay.hide();
      bodyStyle.overflow = 'auto';
    }
  }

  const logCartDetailsToSegment = () => {
    const customerDetails = window?.getCustomerDetails?.();
    const gtmDetails = JSON.parse(localStorage.getItem('___ELEVAR_GTM_SUITE--params') || '{}');

    analytics.track('Cart Viewed', {
      fbcid: gtmDetails?.fbclid,
      gclid: gtmDetails?.gclid,
    },
    {
      ...(customerDetails ? { userId: customerDetails?.segmentUserId } : {}),
      context: {
        traits: {
          ...(customerDetails
            ? { stio_unique_user_id: customerDetails?.segmentUserId, email: customerDetails?.email }
            : {}),
        },
      },
    });
  }

  overlay.on('cancel', () => {
    toggle(false);
  });

  watch(totalCount, () => {
    updateComponentIfNeeded();
  });
</script>
